export const UPLOAD_STATUS = {
  pending: "pending",
  uploading: "uploading",
  done: "done",
  error: "error",
} as const;

export type UploadStatus = (typeof UPLOAD_STATUS)[keyof typeof UPLOAD_STATUS];

export interface CaptureSide {
  alias: string;
  view: string;
  url: string;
}

export interface CloudinaryUploadResult {
  secure_url: string;
  public_id: string;
}

export interface UploadedCaptureResult {
  url: string;
  publicId: string;
}

export interface SubmissionItem {
  alias: string;
  view: string;
  url: string;
  status: UploadStatus;
}

export interface SubmissionProgress {
  items: SubmissionItem[];
  apiStatus: UploadStatus;
  results: Record<string, UploadedCaptureResult>;
}

export interface UploadJob {
  index: number;
  alias: string;
  file: string;
}

export interface UploadBatchHandlers {
  onItemUploading?: (index: number, alias: string) => void;
  onItemSuccess?: (
    index: number,
    alias: string,
    data: CloudinaryUploadResult
  ) => void;
  onItemError?: (index: number, alias: string, err: Error) => void;
}
